import { render, staticRenderFns } from "./SalesPaymentViewGlobal.vue?vue&type=template&id=1f626671"
import script from "./SalesPaymentViewGlobal.vue?vue&type=script&lang=js"
export * from "./SalesPaymentViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports